import { render, staticRenderFns } from "./settings-organization-rate-card.vue?vue&type=template&id=186a20c4&scoped=true&"
import script from "./settings-organization-rate-card.vue?vue&type=script&lang=js&"
export * from "./settings-organization-rate-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186a20c4",
  null
  
)

export default component.exports